import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchInvoicesThunk,
  selectBillingState,
  setBillingCurrentPage,
} from "../store/billingSlice";

export const useBillingInvoices = () => {
  const dispatch = useDispatch();
  const state = useSelector(selectBillingState);

  useEffect(() => {
    if (state.hasLoaded) return;
    dispatch(fetchInvoicesThunk());
  }, [dispatch, state.hasLoaded]);

  return {
    ...state,
    setCurrentPage: (value) => dispatch(setBillingCurrentPage(value)),
    refreshInvoices: () => dispatch(fetchInvoicesThunk()),
  };
};

export default useBillingInvoices;
